import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { HolidaySettings } from "./HolidaySettings";
import { useSettings } from "./hooks/useSettings";
import { ProjectTaskSettings } from "./ProjectsTasks";
import { useSearchParams } from "react-router-dom";
import { StyledTabPanel } from "./styles";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <StyledTabPanel
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </StyledTabPanel>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const SettingsTabs = () => {
  const [value, setValue] = React.useState(0);
  const [searchParams,setSearchParams] = useSearchParams();
  const savedTab = searchParams.get('refTab');
  const {
    holidaysList,
    createEditHoliday,
    deleteHoliday,
    holidayToast,
    holidaysLoading,
    projectTasksLoading,
    projectTasksToast,
    projectTasks,
    createEditProjectTasks,
    deleteTask,
    YEAR_FILTER_OPTIONS,
    handleYearChange,selectedYear,
    handleHolidayToastClose,
    handleProjectToastClose,
  } = useSettings();
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSearchParams(`refTab=${newValue}`);
  };
  React.useEffect(()=>{
    if(savedTab!==null){
      setValue(parseInt(savedTab));
    }
  },[savedTab])
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Settings Tabs"
        >
          <Tab label="Holidays" {...a11yProps(0)} />
          <Tab label="Project Tasks" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <HolidaySettings
          holidaysData={holidaysList}
          toastInfo={holidayToast}
          onToastClose={handleHolidayToastClose}
          onCreateEdit={createEditHoliday}
          isLoading={holidaysLoading}
          onDeleteHoliday={deleteHoliday}
          filterOptions={YEAR_FILTER_OPTIONS}
          onYearChange={handleYearChange}
          selectedYear={selectedYear}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ProjectTaskSettings
          isLoading={projectTasksLoading}
          toastInfo={projectTasksToast}
          onToastClose={handleProjectToastClose}
          projectTasksData={projectTasks}
          onCreateEdit={createEditProjectTasks}
          onDeleteTask={deleteTask}
        />
      </CustomTabPanel>
    </Box>
  );
};
